import { createContext, useContext, useState } from "react";

const PredictionsContext = createContext(null);

export function PredictionsProvider({ children }) {
  const [predictions, setPredictions] = useState([]);

  const addPrediction = (match, prediction) => {
    setPredictions((prev) => {
      const filtered = prev.filter((p) => p.match.id !== match.id);
      return [
        ...filtered,
        {
          match,
          prediction,
          submittedAt: new Date().toISOString(),
        },
      ];
    });
  };

  return (
    <PredictionsContext.Provider value={{ predictions, addPrediction }}>
      {children}
    </PredictionsContext.Provider>
  );
}

export function usePredictions() {
  return useContext(PredictionsContext);
}
